module.exports = __webpack_public_path__ + "static/media/carolGloriaKathy63.d6d95b2d.png";